// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/settings';

const productRouter =
  {
    path: roterPre+'/product',
    name: 'product',
    component: Layout,
    meta: {
      icon: 'dashboard',
      title: '商品管理'
    },
    alwaysShow: true,
    redirect: 'noRedirect',
    children: [
      {
        path: 'classify',
        name: 'ProductClassify',
        meta: {
          title: '商品分类',
          noCache: true
        },
        component: () => import('@/views/product/productClassify/index.vue')
      },
      {
        path: 'attr',
        name: `ProductAttr`,
        meta: {
          title: '商品规格',
          noCache: true
        },
        component: () => import('@/views/product/productAttr/index.vue')
      },
      {
        path: 'label',
        name: `ProductLabel`,
        meta: {
          title: '商品标签',
          noCache: true
        },
        component: () => import('@/views/product/productLabel/index.vue')
      },
      {
        path: 'list',
        name: `ProductList`,
        meta: {
          title: '商品列表',
          noCache: true
        },
        component: () => import('@/views/product/productList/index.vue')
      },
      {
        path: 'list/addProduct/:id?/:edit?',
        component: () => import('@/views/product/addProduct/index.vue'),
        name: 'AddProduct',
        meta: { title: '商品添加', noCache: true, activeMenu: `${roterPre}/product/list` },
        hidden: true
      },
      {
        path: 'cdKey',
        name: `ProductCdKey`,
        meta: {
          title: '卡密管理',
          noCache: true
        },
        component: () => import('@/views/product/cdkey/index.vue')
      },
      {
        path: 'cdkey/creatCdkey',
        component: () => import('@/views/product/cdkey/creatCdkey.vue'),
        name: 'creatCdkey',
        meta: { title: '卡密添加',
        noCache: true,
        activeMenu: `${roterPre}/product/cdKey` },
      },
      {
        path: 'reviews',
        name: 'ProductReviews',
        meta: {
          title: '商品评论', noCache: true, activeMenu: `${roterPre}/product/reviews`
        },
        component: () => import('@/views/product/Reviews/index.vue')
      },
      {
        path: 'reservation',
        name: 'ProductReservation',
        meta: {
          title: '预约设置', noCache: true, activeMenu: `${roterPre}/product/reservation`
        },
        component: () => import('@/views/product/reservationSetting/index.vue')
      },
      {
        path: 'specs',
        name: 'ProductSpecs',
        meta: {
          title: '商品参数',
          noCache: true,

        },
        component: () => import('@/views/product/specs/list.vue')
      },
      {
        path: 'specs/create/:id?',
        name: 'ProductSpecsCreate',
        meta: {
          title: '添加参数模板',
          noCache: true,
          activeMenu: `${roterPre}/product/specs`
        },
        component: () => import('@/views/product/specs/create.vue')
      },
      {
        path: 'unit',
        name: `ProductUnit`,
        meta: {
          title: '商品单位',
          noCache: true,
          activeMenu: `${roterPre}/product/unit`
        },
        component: () => import('@/views/product/productUnit/index.vue')
      },
    ]
  }

export default productRouter as RouteRecordRaw